import {Modal} from "react-bootstrap";
import AutocompleteAddressInput from "../../shared/components/AutocompleteAddressInput";
import {useForm} from "react-hook-form";
import {useEffect, useState} from "react";
import FormControl from "../../shared/components/FormControl";
import CustomInput from "../../shared/components/CustomInput";
import {customerService} from "../../services/customerService";
import {SplitAddressFromGoogleAddressComponents} from "../../shared/sharedFunctions";
import {useNavigate} from "react-router-dom";

interface NewCustomerModalProps {
    show: boolean;
    toggle: () => void;
}

const NewCustomerModal: React.FC<NewCustomerModalProps> = ({ show, toggle}) => {
    const { register, trigger, setValue, handleSubmit, getValues, formState: {errors} } = useForm();
    const [place, setPlace] = useState<any>(null);
    const [addressMissing, setAddressMissing] = useState<any>(false);
    const navigate = useNavigate()
    const onSubmit = async () => {
        const validation = await trigger();
        if(!place) setAddressMissing(true)
        else setAddressMissing(false)
        if(!validation || !place) return;
        const splitAddress = SplitAddressFromGoogleAddressComponents(place.address_components)
        setValue("standardizedAddress", place.formatted_address);
        setValue("streetNumber",    splitAddress.streetNumber);
        setValue("streetPrefix",    splitAddress.streetPrefix);
        setValue("streetName",      splitAddress.streetName);
        setValue("streetSuffix",    splitAddress.streetSuffix);
        setValue("streetPostDirection", splitAddress.streetPostDirection);
        setValue("city",            splitAddress.city);
        setValue("state",           splitAddress.state);
        setValue("county",           splitAddress.county);
        setValue("postalCode",      splitAddress.postalCode);
        customerService.createNewCustomer(getValues()).then(r => {
            if(!r) return;
            toggle();
            customerService.getCustomerById(r.customerId).then(r => {
                navigate('/admin/customer-details', {
                    state: {
                        customerId: r.customerId,
                        customerName: r.businessName ? r.businessName : r.firstName + ' ' + r.lastName,
                        propertyAddress: r.standardizedAddress,
                    }
                });
            })
        })
    }
    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header>
                <h4 className="modal-title" id="exampleModalLabel">Add Customer</h4>
                <button type="button" onClick={toggle} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </Modal.Header>
            <Modal.Body>
                <div className="row gx-3">
                    <div className="col-md-6 mb-3">
                        <CustomInput label={'First Name'} name={'firstName'} className={'form-control'}
                                     register={register} errors={errors}/>
                    </div>
                    <div className="col-md-6 mb-3">
                        <CustomInput label={'Last Name'} name={'lastName'} className={'form-control'}
                                     register={register} errors={errors} required/>
                    </div>
                </div>
                <div className="row gx-3">
                    <div className="col-12 mb-3">
                        <label htmlFor="userAddress" className="form-label">Address<sup className="text-danger">*</sup></label>
                        <AutocompleteAddressInput onLocation={(place) => {
                        }} setPlace={setPlace} className={"form-control form-control-sm"}
                                                  addressMissing={addressMissing}/>
                    </div>
                </div>
                <div className="row gx-3">
                    <div className="col-12 mb-3">
                        <label htmlFor="selectInput" className="form-label">Property Type</label>
                        <select {...register("propertyType")}
                                className="form-select form-select-sm"
                                aria-label="Property Type" id="selectInput">
                            <option value="Unspecified" selected>Select</option>
                            <option value="Residential">Residential</option>
                            <option value="Commercial">Commercial</option>
                        </select>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button type="button" onClick={toggle} className="btn btn-light text-strong m-100"
                        data-bs-dismiss="modal">Cancel
                </button>
                <button type="button" onClick={onSubmit} className="btn btn-primary text-strong m-100">Save</button>
            </Modal.Footer>
        </Modal>
    );
}
export default NewCustomerModal